import { DeletePage } from '../crud/shared.js';

export class SupportDelete extends DeletePage {
  static get formAction() {
    return API.resourceUrl('support', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Support" href="/support" nameHref="/support/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Delete" suffixStyle="" suffixSeparatorStyle="">

    form.stacked-form[method="DELETE" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/support"]
      p Please confirm deleting this item.
      .horizontal-flex.mt-15
        <FormButton label="Confirm Delete">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}"] Back
  `;

  static javascript() {
    API.get(API.resourceUrl('support', Routing.params.id))
      .then(data => {
        document.querySelector('#name').innerHTML = data.data.subject;
      });
  }
}
